import { Typography } from 'components';
import { TYPES_ACTION } from '../../@types';

export const Alert = ({
  typeAction,
  totalFigurantsSelected,
  totalFigurant,
  type,
}: {
  typeAction: TYPES_ACTION;
  totalFigurantsSelected: number;
  totalFigurant: number;
  type?: string;
}) => {
  return (
    <>
      {totalFigurant > totalFigurantsSelected && typeAction !== TYPES_ACTION.LICENSE && (
        <Typography sx={{ my: 1, color: '#B30303', fontSize: '14px' }}>
          {type === '5' ? 'Falta fiscal a ser escalado' : 'Faltam figurantes a serem escalados'}
        </Typography>
      )}

      {totalFigurant < totalFigurantsSelected && typeAction !== TYPES_ACTION.LICENSE && (
        <Typography sx={{ my: 1, color: '#B30303', fontSize: '14px' }}>
          {type !== '5' && 'O número de figurantes excedeu o limite do pedido.'}
        </Typography>
      )}

      {totalFigurant === totalFigurantsSelected && typeAction !== TYPES_ACTION.LICENSE && type !== '2' && (
        <Typography sx={{ my: 1, color: '#417505', fontSize: '14px' }}>
          Todos os figurantes foram escalado(s), para seleção do fiscal, clique em próximo.
        </Typography>
      )}
      {typeAction === TYPES_ACTION.LICENSE && !totalFigurantsSelected && type !== '2' && (
        <Typography sx={{ my: 1, color: '#B30303', fontSize: '14px' }}>Nenhum figurante associado!</Typography>
      )}
    </>
  );
};
